import { Component, namespace, Vue } from 'nuxt-property-decorator'
import isEmpty from 'lodash/isEmpty'
import { Experience } from '~/types/experience'
import formatParamsAndQuery from '~/components/experience/format-params-and-query'

import UrlQuery = Experience.UrlQuery
import TreeNode = Experience.TreeNode

const experience = namespace('experience')

@Component
export default class Index extends Vue {
  @experience.Action getSearchResult!: Function
  @experience.State urlQuery!: UrlQuery
  @experience.State searchResultActivities!: string
  @experience.State categoryTreeData!: any
  @experience.State rangeData!: any
  @experience.State searchPageStatus!: string
  @experience.State pageType!: string
  @experience.State filter!: string

  rangeAllDisable: boolean = true

  get isAbExperiment() {
    return this.filter && !isEmpty(this.filter)
  }

  get keyWord() {
    return this.urlQuery.keyword
  }

  get notFilterPage() {
    return ['search', 'mfo'].includes(this.pageType)
  }

  get showMain() {
    if (this.notFilterPage) {
      return this.searchResultActivities?.length
    }

    return true
  }

  get showNoResult() {
    const status = this.searchPageStatus !== 'fetching'
    const noActivities = this.searchResultActivities?.length === 0
    return this.notFilterPage && noActivities && status
  }

  get findDestination() {
    // country_ids=1,2,3,4 或者 country_ids=1 或者无 country_ids=''
    // city_ids=1,2,3,4 或者 city_ids=1 或者无 city_ids=''
    const { country_ids: countryId, city_ids: cityId } = this.urlQuery
    this.matchId(this.rangeData, 0, 0)
    let a = true
    if (Number(countryId) && Number(cityId)) {
      // 若搜索的国家和城市都只有一个，则不展示无结果样式
      return true
    } else if (isNaN(Number(countryId)) || isNaN(Number(cityId))) {
      // 若搜索的国家不止一个或者城市不止一个，则不展示无结果样式
      return true
    } else if (Number(countryId) || Number(cityId)) {
      // 若搜索的只有一个国家或者只有一个城市，则判断 id 是否在 range 树中匹配上，并且没有 disable
      a = this.matchId(this.rangeData,
        Number(countryId) || 0, Number(cityId) || 0)
    }
    return a
  }

  matchId(list: TreeNode[], countryId: number, cityId: number): any {
    return list.find((item: TreeNode) => {
      if (!item.disabled) {
        this.rangeAllDisable = false
        if (item.type === 'country' && item.id === countryId) {
          return true
        }
        if (item.type === 'city' && item.id === cityId) {
          return true
        }
        return item.children && this.matchId(item.children, countryId, cityId)
      }
      return false
    })
  }

  async refresh() {
    const query: UrlQuery = formatParamsAndQuery(this.$route)
    query.page = query.page ?? 1
    await this.getSearchResult(query)
  }
}
